<script>
    import LoadingIcon from "./LoadingIcon.svelte";
    import {onMount} from "svelte";
    import {calcTimeByOffset, parseDateFromString, dateToSqlFormat} from "../lib/Common.svelte";
    import {_} from '../lib/i18n';
    import Timer from "./Timer.svelte";
    import {Constans} from "../lib/Constants";
    import ChangeTempEmailModal from "./ChangeTempEmailModal.svelte";
    import ReanalyzeDatesControl from "./ReanalyzeDatesControl.svelte";

    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    export let language = 'ru-RU';

    export let subscriptionIsExpired = false;

    export let analyze;
    export let date;

    let temporary;
    $: // noinspection RedundantConditionalExpressionJS
        temporary = (analyze && analyze.temporary ? true : false);

    let username;
    $: username = (analyze && analyze.account ? analyze.account.username : '');

    let lastRevisionDate;
    //$: lastRevisionDate = (analyze ? new Date(analyze.feedsLastUpdate * 1000) : (new Date()));
    //$: analyze && lastRevisionDate.setSeconds(lastRevisionDate.getTimezoneOffset() * 60);
    $: lastRevisionDate = analyze ? parseDateFromString(analyze.feedsLastUpdateDate) : calcTimeByOffset(Constans.timeZoneOffset);
    $: analyzeApproximateFinish = (new Date(lastRevisionDate.getTime())).setSeconds(lastRevisionDate.getSeconds() + Constans.approximateAnalyzeTime);

    let startInProgress = false;

    let isFinished = false;
    $: analyze && (isFinished = analyze.checkIsFinished());

    let refreshAvailableIn = '';
    let refreshInterval;
    onMount(() => {
        refreshInterval = setInterval(() => {
            const targetDate = new Date(lastRevisionDate.getTime());
            targetDate.setDate(targetDate.getDate() + 1);
            const now = calcTimeByOffset(Constans.timeZoneOffset);
            let delta = Math.abs(targetDate.getTime() - now.getTime()) / 1000;

            const days = Math.floor(delta / 86400);
            delta -= days * 86400;

            const hours = Math.floor(delta / 3600) % 24;
            delta -= hours * 3600;

            const minutes = Math.floor(delta / 60) % 60;
            delta -= minutes * 60;

            const seconds = Math.floor(delta % 60);  // in theory the modulus is not required

            refreshAvailableIn = `${hours}:${minutes}:${seconds}`;
        }, 1000);
    });

    async function startAnalyze() {
        if (identity.is_temporary_email) {
            showChangeTempEmailModal = true;
            return;
        }


        if (identity.spy_balance <= 0) return;

        startInProgress = true;

        const result = await params.createAnalyze(username, 1, 0);
        if (result) {
            console.log(result);
        }

        startInProgress = false;
    }

    async function updateAnalyze() {
        startInProgress = true;

        const result = await analyze.forceFeedUpdate();
        if (result) {
            //analyze.feedsLastUpdate = Math.round(calcTimeByOffset(3).getTime() / 1000); //Math.round((new Date(new Date().toLocaleString('en', {timeZone: 'Europe/Moscow'}))).getTime() / 1000);
            //analyze.feedsLastUpdateDate = dateToSqlFormat(calcTimeByOffset(3));
            //analyze.last_revision_epoch = Math.round(calcTimeByOffset(3).getTime() / 1000); //Math.round((new Date(new Date().toLocaleString('en', {timeZone: 'Europe/Moscow'}))).getTime() / 1000);
            analyze = analyze;
        }

        startInProgress = false;
    }

    let completeTimer = false;
    let lastUpdate;
    $: lastUpdate = (analyze && analyze.feedsLastUpdate ? new Date(analyze.feedsLastUpdate * 1000) : (new Date()));

    let authRequired;
    $: authRequired = (analyze ? (analyze.is_private && (!analyze.handler || analyze.is_not_friend)) : false);

    let updateDataButtonIsDisabled = false;
    let refreshDataAvailable = false;
    $: refreshDataAvailable = (calcTimeByOffset(Constans.timeZoneOffset).getTime() > (lastRevisionDate.getTime() + 86400 * 1000 * Constans.reanalyzeAvailableInDays))
    $: updateDataButtonIsDisabled = startInProgress || authRequired || subscriptionIsExpired || !refreshDataAvailable;


    let identity;
    $: identity = (params ? params.identity : null);
    let showBindCard;
    $: showBindCard = identity ? identity.spy_show_first_pay_modal : false;

    let showChangeTempEmailModal = false;

</script>

<section class="feed-update-block tail">
    <h2 class="feed-update-block__title tail__title">{$_('analyzeControl.blockTitle')}</h2>

    {#if temporary || authRequired}
        <p class="feed-update-block__text tail__text">{$_('analyzeControl.blockInitialDescription')}</p>
        <button class="button button_icon-text button_shadow feed-update-block__btn"
                disabled={startInProgress || showBindCard || (identity.spy_balance <= 0) || subscriptionIsExpired}
                on:click={startAnalyze}>
            {#if startInProgress}
                <LoadingIcon show={startInProgress} width="16" height="16" />
            {:else}
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.11719 6.95599L2.70818 9.71167L5.46385 8.12068M16.8815 11.044L15.2905 8.28833L12.5348 9.87932M14.9993 9C14.9993 12.3137 12.3131 15 8.99935 15C7.35497 15 5.86509 14.3385 4.7813 13.2671M2.99935 9C2.99935 5.68629 5.68564 3 8.99935 3C10.6556 3 12.1551 3.67106 13.2407 4.75611" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
            {/if}
            <span>{$_('analyzeControl.startAnalyzeBtnLabel')}</span>
        </button>
    {:else}
        {#if isFinished}
            <button disabled={updateDataButtonIsDisabled}
                    class="button button_icon-text button_shadow feed-update-block__btn"
                    on:click={updateAnalyze}
            >
                {#if startInProgress}
                    <LoadingIcon show={startInProgress} width="16" height="16" />
                {:else}
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.11719 6.95599L2.70818 9.71167L5.46385 8.12068M16.8815 11.044L15.2905 8.28833L12.5348 9.87932M14.9993 9C14.9993 12.3137 12.3131 15 8.99935 15C7.35497 15 5.86509 14.3385 4.7813 13.2671M2.99935 9C2.99935 5.68629 5.68564 3 8.99935 3C10.6556 3 12.1551 3.67106 13.2407 4.75611" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                {/if}
                <span>{$_('analyzeControl.reanalyzeBtnLabel')}</span>
            </button>
            {#if !refreshDataAvailable}
                <p class="feed-update-block__text tail__text time-till-next-title">
                    {$_('analyzeControl.timeTillNextUpdate')}:
                </p>
                <p class="feed-update-block__text tail__text">
                    {refreshAvailableIn}
                </p>
            {/if}
        {:else}
            <p class="feed-update-block__text tail__text">
                {@html $_('analyzeControl.analyzeInProgressDescription')}
            </p>
            <button class="button button_icon-text button_shadow feed-update-block__btn feed-update-block__btn_loading"
                    disabled>
                    <LoadingIcon show={true} width="16" height="16" />
                <span>{$_('analyzeControl.analyzeInProgressStatus')}</span>
                {#if language === 'en-US'}
                    <Timer bind:complete = {completeTimer} targetDate={analyzeApproximateFinish} />
                {/if}
            </button>
        {/if}
    {/if}
    {#if analyze && analyze.available_dates && analyze.available_dates.length > 0}
        {#key analyze.available_dates.length}
            <ReanalyzeDatesControl
                dates={analyze.available_dates}
                bind:date
                on:change = {(e) => {
                    analyze.updateResult(analyze.id, e.detail.date);
                }}
            />
        {/key}
    {/if}
</section>

<ChangeTempEmailModal params={params} bind:show={showChangeTempEmailModal} {analyze} />

<style>
    .tail__text.time-till-next-title {
        margin-bottom: 0;
    }
</style>